module.exports = __webpack_public_path__ + "static/media/roku.2d9520f2.png";